import React from "react";

// 기본 파일 아이콘 컴포넌트
const FileIcon = ({ type, size = 64, className = "" }) => {
  const icons = {
    pdf: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#D32F2F" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          PDF
        </text>
        <rect x="16" y="42" width="24" height="2" rx="1" fill="#e5e5e5" />
        <rect x="16" y="47" width="20" height="2" rx="1" fill="#e5e5e5" />
      </svg>
    ),
    doc: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#1565C0" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          DOC
        </text>
        <rect x="16" y="42" width="24" height="2" rx="1" fill="#e5e5e5" />
        <rect x="16" y="47" width="20" height="2" rx="1" fill="#e5e5e5" />
      </svg>
    ),
    docx: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#1565C0" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="8"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          DOCX
        </text>
        <rect x="16" y="42" width="24" height="2" rx="1" fill="#e5e5e5" />
        <rect x="16" y="47" width="20" height="2" rx="1" fill="#e5e5e5" />
      </svg>
    ),
    xls: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#2E7D32" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          XLS
        </text>
        <g stroke="#e5e5e5" strokeWidth="1.5" fill="none">
          <line x1="16" y1="42" x2="16" y2="50" />
          <line x1="24" y1="42" x2="24" y2="50" />
          <line x1="32" y1="42" x2="32" y2="50" />
          <line x1="40" y1="42" x2="40" y2="50" />
          <line x1="16" y1="42" x2="40" y2="42" />
          <line x1="16" y1="46" x2="40" y2="46" />
          <line x1="16" y1="50" x2="40" y2="50" />
        </g>
      </svg>
    ),
    xlsx: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#2E7D32" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="8"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          XLSX
        </text>
        <g stroke="#e5e5e5" strokeWidth="1.5" fill="none">
          <line x1="16" y1="42" x2="16" y2="50" />
          <line x1="24" y1="42" x2="24" y2="50" />
          <line x1="32" y1="42" x2="32" y2="50" />
          <line x1="40" y1="42" x2="40" y2="50" />
          <line x1="16" y1="42" x2="40" y2="42" />
          <line x1="16" y1="46" x2="40" y2="46" />
          <line x1="16" y1="50" x2="40" y2="50" />
        </g>
      </svg>
    ),
    csv: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#2E7D32" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          CSV
        </text>
        <g stroke="#e5e5e5" strokeWidth="1.5" fill="none">
          <line x1="16" y1="42" x2="16" y2="50" />
          <line x1="24" y1="42" x2="24" y2="50" />
          <line x1="32" y1="42" x2="32" y2="50" />
          <line x1="40" y1="42" x2="40" y2="50" />
          <line x1="16" y1="42" x2="40" y2="42" />
          <line x1="16" y1="46" x2="40" y2="46" />
          <line x1="16" y1="50" x2="40" y2="50" />
        </g>
      </svg>
    ),
    ppt: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#EF6C00" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          PPT
        </text>
        <rect x="16" y="42" width="24" height="2" rx="1" fill="#e5e5e5" />
        <rect x="16" y="47" width="20" height="2" rx="1" fill="#e5e5e5" />
      </svg>
    ),
    pptx: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#EF6C00" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="8"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          PPTX
        </text>
        <rect x="16" y="42" width="24" height="2" rx="1" fill="#e5e5e5" />
        <rect x="16" y="47" width="20" height="2" rx="1" fill="#e5e5e5" />
      </svg>
    ),
    txt: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#757575" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          TXT
        </text>
        <rect x="16" y="42" width="24" height="2" rx="1" fill="#e5e5e5" />
        <rect x="16" y="47" width="20" height="2" rx="1" fill="#e5e5e5" />
        <rect x="16" y="52" width="16" height="2" rx="1" fill="#e5e5e5" />
      </svg>
    ),
    zip: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#FFC107" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          ZIP
        </text>
        <rect x="26" y="10" width="4" height="4" fill="#e5e5e5" />
        <rect x="30" y="14" width="4" height="4" fill="#e5e5e5" />
        <rect x="26" y="18" width="4" height="4" fill="#e5e5e5" />
        <rect x="24" y="42" width="8" height="8" rx="1" fill="#FFC107" />
        <line
          x1="28"
          y1="44"
          x2="28"
          y2="48"
          stroke="#ffffff"
          strokeWidth="1.5"
        />
      </svg>
    ),
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#9C27B0" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          IMG
        </text>
        <rect x="16" y="40" width="24" height="16" rx="2" fill="#f5f5f5" />
        <circle cx="22" cy="46" r="2" fill="#9C27B0" />
        <path d="M16 52l6-6l4 4l8-8l6 10H16z" fill="#9C27B0" opacity="0.6" />
      </svg>
    ),
    video: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#E91E63" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          MP4
        </text>
        <rect x="16" y="42" width="24" height="12" rx="2" fill="#f5f5f5" />
        <path d="M24 45v6l6-3z" fill="#E91E63" />
      </svg>
    ),
    audio: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#673AB7" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          MP3
        </text>
        <path
          d="M20 46h2v6h-2zm4-3h2v9h-2zm4 2h2v5h-2zm4-4h2v9h-2zm4 2h2v5h-2z"
          fill="#673AB7"
        />
      </svg>
    ),
    hwp: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#00ACC1" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          HWP
        </text>
        <rect x="16" y="42" width="24" height="2" rx="1" fill="#e5e5e5" />
        <rect x="16" y="47" width="20" height="2" rx="1" fill="#e5e5e5" />
      </svg>
    ),
    default: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
      >
        <path
          d="M12 4h22l10 10v36c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4z"
          fill="#ffffff"
          stroke="#c9c9c9"
        />
        <path d="M34 4v10c0 2.2 1.8 4 4 4h10L34 4z" fill="#eeeeee" />
        <rect x="14" y="24" width="28" height="12" rx="3" fill="#9E9E9E" />
        <text
          x="28"
          y="33"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="#ffffff"
          fontFamily="Segoe UI, Arial, sans-serif"
        >
          FILE
        </text>
        <rect x="16" y="42" width="24" height="2" rx="1" fill="#e5e5e5" />
        <rect x="16" y="47" width="20" height="2" rx="1" fill="#e5e5e5" />
      </svg>
    ),
  };

  // 파일 타입 판별
  const getIconType = (fileType) => {
    const ext = (fileType || "").toLowerCase().replace(".", "");

    if (icons[ext]) return ext;

    // 이미지 파일들
    if (["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"].includes(ext))
      return "image";

    // 비디오 파일들
    if (["mp4", "avi", "mov", "wmv", "flv", "mkv"].includes(ext))
      return "video";

    // 오디오 파일들
    if (["mp3", "wav", "flac", "aac", "ogg", "m4a"].includes(ext))
      return "audio";

    // 압축 파일들
    if (["rar", "7z", "tar", "gz"].includes(ext)) return "zip";

    return "default";
  };

  const iconType = getIconType(type);
  return icons[iconType] || icons.default;
};

// 작은 아이콘용 간단한 버전
export const SimpleFileIcon = ({ type, size = 24, className = "" }) => {
  const colors = {
    pdf: "#D32F2F",
    doc: "#1565C0",
    docx: "#1565C0",
    xls: "#2E7D32",
    xlsx: "#2E7D32",
    csv: "#2E7D32",
    ppt: "#EF6C00",
    pptx: "#EF6C00",
    txt: "#757575",
    zip: "#FFC107",
    image: "#9C27B0",
    video: "#E91E63",
    audio: "#673AB7",
    hwp: "#00ACC1",
    default: "#9E9E9E",
  };

  const getColor = (fileType) => {
    const ext = (fileType || "").toLowerCase().replace(".", "");

    if (colors[ext]) return colors[ext];

    if (["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"].includes(ext))
      return colors.image;
    if (["mp4", "avi", "mov", "wmv", "flv", "mkv"].includes(ext))
      return colors.video;
    if (["mp3", "wav", "flac", "aac", "ogg", "m4a"].includes(ext))
      return colors.audio;
    if (["rar", "7z", "tar", "gz"].includes(ext)) return colors.zip;

    return colors.default;
  };

  const color = getColor(type);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        d="M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6H6z"
        fill={color}
        opacity="0.9"
      />
      <path d="M14 2v6h6" fill={color} opacity="0.6" />
      <path
        d="M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6H6zm0 2h7v5h5v11H6V4z"
        fill="none"
        stroke="#ffffff"
        strokeWidth="0.5"
        opacity="0.8"
      />
    </svg>
  );
};

export default FileIcon;
